var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAustr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.23287C22.3139 1.23334 22.6743 1.36659 22.9401 1.60338C23.2059 1.84017 23.3555 2.16121 23.356 2.49608V20.2022C23.3555 20.5371 23.2059 20.8581 22.9401 21.0949C22.6743 21.3317 22.3139 21.4649 21.938 21.4654H2.06201C1.6861 21.4649 1.32572 21.3317 1.05991 21.0949C0.7941 20.8581 0.644523 20.5371 0.643994 20.2022V2.49608C0.644523 2.16121 0.7941 1.84017 1.05991 1.60338C1.32572 1.36659 1.6861 1.23334 2.06201 1.23287H21.938ZM21.938 0.65918H2.06201C1.5153 0.659651 0.991126 0.853341 0.604541 1.19772C0.217956 1.5421 0.000529505 2.00905 0 2.49608V20.2022C0.000529505 20.6892 0.217956 21.1562 0.604541 21.5005C0.991126 21.8449 1.5153 22.0386 2.06201 22.0391H21.938C22.4845 22.0382 23.0084 21.8443 23.3949 21.5C23.7813 21.1558 23.9989 20.6891 24 20.2022V2.49608C23.9995 2.00905 23.782 1.5421 23.3955 1.19772C23.0089 0.853341 22.4847 0.659651 21.938 0.65918Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643921 20.2023C0.64445 20.5372 0.794027 20.8582 1.05984 21.095C1.32565 21.3318 1.68602 21.4651 2.06194 21.4655H21.9379C22.3138 21.4651 22.6742 21.3318 22.94 21.095C23.2058 20.8582 23.3554 20.5372 23.3559 20.2023V14.9126H0.643921V20.2023Z",
    fill: "#E42328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 1.23291H2.06194C1.68602 1.23338 1.32565 1.36663 1.05984 1.60342C0.794027 1.84022 0.64445 2.16125 0.643921 2.49612V7.77516H23.3559V2.49612C23.3554 2.16125 23.2058 1.84022 22.94 1.60342C22.6742 1.36663 22.3138 1.23338 21.9379 1.23291Z",
    fill: "#E42328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3559 7.7749H0.643921V14.9069H23.3559V7.7749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.65918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustr);
export default __webpack_public_path__ + "static/media/austr.4b99f53f577c8a687af3ef571b9396d9.svg";
export { ForwardRef as ReactComponent };